import type { IStore } from "~/state/store";
import type { TWasmMapHover } from "../wasm";
import type WasmStoreMapping from "../mapping";

export function onHover(data: TWasmMapHover, store: IStore, mapping: WasmStoreMapping) {
	//console.log("hover", data.poi ? `${data.poi.source}-${data.poi.id}` : data.wasmId, data.type);
	// vlastni body - hover nad markerem
	if (Mapy.getComponent("userMarks").isActive() && data.type !== "move" && data.wasmId) {
		const storeId = mapping.getWasmToStoreId(data.wasmId);
		const { markers } = store.getState().mapContent;
		const userMarksMarker = markers.find(marker => marker.id === storeId);

		if (userMarksMarker?.type === "user-marks") {
			Mapy.getComponent("userMarks").getMain()?.sectionHighlight(data.type === "enter", userMarksMarker.customData?.order - 1);
		}
	}
}
